<template>
    <div>

        <div class="vx-row">
            <div class="vx-col sm:w-full md:w-full">
                <h5 class="color mt-5">{{ $t('notificationV.notificationType') }}</h5>
            </div>
            <div class="vx-col md:w-1/2 mt-2 flex">
                <vs-checkbox class="mt-2" v-model="firebaseCheckBoxModel"></vs-checkbox>
                <span class="mt-2">{{ $t('notificationV.viaApp') }}</span>
            </div>
        </div>
        <div class="vx-row notification-setting">
            <div class="vx-col sm:w-full md:w-1/2">
                <div class="w-full md:w-5/12 mt-2 flex">
                    <vs-checkbox class="mt-2" v-model="emailCheckBoxModel"></vs-checkbox>
                    <span class="mt-2">{{ $t('notificationV.email') }}</span>
                </div>
                <div class="vx-col md:w-full p-2" v-if="emailCheckBoxModel">
                    <vue-tags-input :placeholder="$t('notificationV.enterEmail')"
                                    v-model="email"
                                    :tags=notificationSetting.emailList
                                    @tags-changed="newTags => notificationSetting.emailList = newTags"
                                    @before-adding-tag="checkTag"
                                    @input="checkEmail"
                                    allow-edit-tags
                                    v-validate="'required|email|min:3|max:50'"
                                    name="email"
                    />
                    <span class="text-danger text-sm">{{ errors.first("email")}}</span>
                </div>
            </div>

            <div class="vx-col sm:w-full md:w-1/2 mt-2">
                <div class="w-full flex">
                    <vs-checkbox class="mt-2" v-model="smsCheckBoxModel"></vs-checkbox>
                    <span class="mt-2">{{ $t('notificationV.phoneNumber') }}</span>
                </div>

                <div class="vx-col md:w-full p-2" v-if="smsCheckBoxModel">
                    <vue-tags-input :placeholder="$t('notificationV.enterPhone')"
                                    v-model="phoneNumber"
                                    :tags= notificationSetting.phoneNumberList
                                    @tags-changed="newTags => notificationSetting.phoneNumberList = newTags"
                                    @before-adding-tag="checkTag"
                                    allow-edit-tags
                                    v-validate="'numeric|min:10|max:11'"
                                    name="phoneNumber"
                    />
                    <span class="text-danger text-sm">{{ errors.first("phoneNumber")}}</span>
                </div>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col md:w-2/3">
                <h5 class="color mt-5">{{ $t('notificationV.notifTime') }}</h5>
                <span class="ml-5" style="font-size: 12px;">{{ $t('notificationV.dragScroll') }}</span>
            </div>
            <div class="vx-col md:w-1/3 flex">
                <vs-checkbox class="mt-2" v-model="notificationSetting.always"></vs-checkbox>
                <span class="mt-6">{{ $t('notificationV.always') }}</span>
            </div>
        </div>
        <WeekComponentNew v-if="!notificationSetting.always" :selectTimes="notificationSetting.timeNotification" :nameEventBus="notificationSetting.nameEventBusUse"></WeekComponentNew>

    </div>
</template>

<script>
    import WeekComponentNew from "../week-time/WeekComponentNew";
    import VueTagsInput from '@johmun/vue-tags-input';

    //Camera Event Notification Types
    const FIRE_BASE = 0;
    const EMAIL = 1;
    const SMS = 2;

    export default {
        name: "NotificationSetting",
        data() {
            return {
                email: '',
                phoneNumber: '',
                settings: {
                    maxScrollbarLength: 60,
                    wheelSpeed: .30,
                    suppressScrollX: true
                },
            }
        },
        computed:{
            validateForm() {
                return !this.errors.any()
            },
            firebaseCheckBoxModel: {
                get() {
                    if (this.notificationSetting.cameraEventNotificationTypes.includes(FIRE_BASE)) return true;
                    return false;
                },
                set(value){
                    if(value) {
                        this.notificationSetting.cameraEventNotificationTypes.push(FIRE_BASE);
                    } else {
                        this.notificationSetting.cameraEventNotificationTypes = this.notificationSetting.cameraEventNotificationTypes.filter(x => x != FIRE_BASE);
                    }
                }
            },
            emailCheckBoxModel: {
                get() {
                    if (this.notificationSetting.cameraEventNotificationTypes.includes(EMAIL)) return true;
                    return false;
                },
                set(value){
                    if(value) {
                        this.notificationSetting.cameraEventNotificationTypes.push(EMAIL);
                    } else {
                        this.notificationSetting.cameraEventNotificationTypes = this.notificationSetting.cameraEventNotificationTypes.filter(x => x != EMAIL);
                    }
                }
            },
            smsCheckBoxModel: {
                get() {
                    if (this.notificationSetting.cameraEventNotificationTypes.includes(SMS)) return true;
                    return false;
                },
                set(value){
                    if(value) {
                        this.notificationSetting.cameraEventNotificationTypes.push(SMS);
                    } else {
                        this.notificationSetting.cameraEventNotificationTypes = this.notificationSetting.cameraEventNotificationTypes.filter(x => x != SMS);
                    }
                }
            }
        },
        components: {
            WeekComponentNew,
            VueTagsInput
        },
        props: {
            notificationSetting: {
                cameraEventStatusType: null,
                cameraEventNotificationTypes:[],
                emailList: [],
                phoneNumberList: [],
                timeNotification: {
                    arr0: [],
                    arr1: [],
                    arr2: [],
                    arr3: [],
                    arr4: [],
                    arr5: [],
                    arr6: []
                },
                nameEventBusUse: 'camera-setting',
                always: true,
            },
        },
        watch: {
            notificationSetting: {
                handler: function (val) {
                    this.$emit('notification-setting-data', val);
                },
                deep: true
            },
        },
        methods: {
            async checkEmail(){
                let result = await this.$validator.validateAll();
                if (!result) this.$eventBus.$emit('check-email-notify', false);
            },
            async checkTag(obj) {
                if (!this.validateForm) return;
                const result = await this.$validator.validateAll();
                if (!result) return;
                this.$eventBus.$emit('check-email-notify', true);
                obj.addTag();
            },
        },
        created() {
        },
        mounted() {
            this.$eventBus.$on(this.notificationSetting.nameEventBusUse, (data) => {
                this.notificationSetting.timeNotification = data.data;
            });
        }
    }
</script>


<style lang="scss">
    .scroll-item {
        max-height: 100px;
    }

    .notification-setting {
        .ti-input {
            max-height: 80px;
            overflow: auto;
            border-radius: 5px;
        }

        .ti-tag {
            height: 25px;
            background-color: rgba(var(--vs-primary),1);
        }
    }
</style>
